<template>
  <div id="menu_main_desktop" :class="{'index': isIndexPage}" class="p-0 col">
    <nav class="navbar navbar-expand-lg static-top p-xl-3 navbar-light bg-faded fixed-top navbar-expand-xl">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false" aria-label="Toggle navigation">
        <span class="sr-only">Prepnúť navigáciu</span>
        <span class="icon-bar first"></span>
        <span class="icon-bar second"></span>
        <span class="icon-bar three"></span>
        <span class="icon-bar four">MENU</span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="container-fluid">
          <div class="row w-100 d-flex align-items-flex-end align-self-center">
            <div class="col-12 col-md-4">
              <ul class="navbar-nav me-auto mt-2 mt-lg-0">
                <li v-for="menuItem in leftMenuItems" class="nav-item px-lg-2 px-xl-2">
                  <NuxtLink :to="menuItem.getLinkWithSlash()" class="nav-link">{{ menuItem.name }}</NuxtLink>
                  <ClientOnly>
                    <span class="badge badge-pill bg-danger message-badge"
                          v-if="menuItem.class.indexOf('message') > -1 && messagesCount > 0">
                      {{ messagesCount }}
                    </span>
                    <span class="badge badge-pill bg-first text-white favorite-badge"
                          v-if="menuItem.class.indexOf('favorite') > -1 && favoritesCount > 0">
                    {{ favoritesCount }}
                  </span>
                  </ClientOnly>
                </li>
              </ul>
            </div>
            <div class="col-4 col-lg-4 text-center d-none d-md-flex">
              <NuxtLink class="navbar-brand mx-auto" :to="`/${activeLocale.code}-${activeCountry.code}`"
                        :title="$t('main-logo-title-alt')">
                <img :src="`/img/logo_${activeCountry.code}.svg`" :alt="$t('main-logo-title-alt')" width="360"
                     height="35" class="img-fluid">
              </NuxtLink>
            </div>
            <div class="col-12 col-md-4 col-lg-4 right">
              <ul class="navbar-nav ms-auto mt-2 mt-lg-0 pe-0">

                <li class="nav-item position-relative">


                  <button @click="langSwitcherModal = true" class="btn btn-language position-relative">
                    <img :src="`/img/flags/New${activeLocale.name}.png`" :alt="activeLocale.name"
                         class="img-cover language_picker" loading="lazy" width="128" height="128">

                    <span class="ms-4">{{ activeLocale.name }}</span>

                  </button>


                </li>

                <ClientOnly>
                  <template v-for="menuItem in rightMenuItems">
                    <li class="nav-item px-lg-2 px-xl-2 position-relative" v-if="menuItem.link === 'login' && !client">
                      <div class="login m-0 btn nav-link d-flex flex-nowrap justify-content-start align-items-center"
                           @click="showLogin">
                        <div class="text-holder lh-1">{{ menuItem.name }}</div>
                        <div class="icon-holder">
                          <TyIcon icon="ty-user" color="black" stroke="black" width="1.4rem" height="1.4rem"
                                  class="me-2"/>
                        </div>
                      </div>
                    </li>
                    <li class="nav-item ps-5 pe-lg-2 pe-xl-2 position-relative" v-else-if="menuItem.link === 'login'">
                      <TyIcon icon="ty-user" class="me-0 user-login-dropdown-icon" width="1.4rem" height="1.4rem"/>

                      <a class="nav-link dropdown-toggle" href="#" id="user_switcher_dropdown" role="button"
                         data-bs-toggle="dropdown" aria-expanded="false">
                        {{ $t('my-account') }}
                      </a>

                      <ul class="dropdown-menu" aria-labelledby="user_switcher_dropdown">
                        <template v-for="subMenuItem in menuItem.childs">
                          <li class="py-2" :key="subMenuItem.id"
                              v-if="(subMenuItem.class.includes('client') && client && client.type ==='client')  || (subMenuItem.class.includes('owner') && client && client.type ==='owner') || (!subMenuItem.class.includes('owner') && !subMenuItem.class.includes('client'))">

                          <span v-if="subMenuItem.class.indexOf('logout') >= 0" :key="subMenuItem.id" @click="logout"
                                class="px-3 bold pointer">{{ subMenuItem.name }}</span>

                            <NuxtLink v-else :to="subMenuItem.getLinkWithSlash(activeLocale, activeCountry)"
                                      class="radius-1-2 px-3 py-2 bold pointer">
                              {{ subMenuItem.name }}
                            </NuxtLink>
                          </li>
                        </template>
                      </ul>
                    </li>
                    <li class="nav-item pe-xl-2 position-relative"
                        v-else-if="menuItem.class ==='add_object' && !client">
                      <NuxtLink
                          class="login m-0 btn nav-link d-flex flex-nowrap justify-content-start align-items-center"
                          :to="`/${menuItem.link}`" :title="menuItem.name">
                        <div class="text-holder lh-1">{{ menuItem.name }}</div>
                        <div class="icon-holder add me-2">
                        </div>
                      </NuxtLink>
                    </li>
                    <li class="nav-item pe-xl-2 position-relative d-none" v-else-if="menuItem.class ==='add_object'">

                      <NuxtLink class="add_object btn btn-first px-3 m-0" v-if="client.type === 'owner'"
                                :to="`/${activeLocale.code}-${activeCountry.code}/admin/accommodations`">
                        {{ menuItem.name }}
                      </NuxtLink>
                    </li>
                  </template>
                </ClientOnly>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>

  <MenuLanguageSwitcherModal :open="langSwitcherModal" @hideLanguageModal="() => langSwitcherModal = false"/>

</template>

<script setup lang="ts">
import "~/assets/less/_menu_main_desktop.min.css";
import Client from "~/lib/models/Client";
import {MenuItem} from "~/lib/models/MenuItem";
import {computed, ComputedRef, PropType, ref} from "vue";
import {PageDataPage} from "~/lib/interfaces/model/PageDataPage";
import {useRoute, useState} from "#app";
import {obtainActiveLocale, obtainActiveWebCountry} from "~/composables/master_page";
import MenuLanguageSwitcherModal from "./menu_language_switcher_modal";
import {useStateFunctionFavorites} from "../../../../../composables/state/favorites";

interface iLanguage {
  code: string;
  iso: string;
  name: string,
  active: boolean,
}


const props = defineProps({
  content: Array as PropType<Array<MenuItem>>,
  messagesCount: Number,
  client: Object as PropType<Client | null>,
  masterPage: Object as PropType<PageDataPage>
})

const emit = defineEmits(['logout']);
const {favorites} = useStateFunctionFavorites();
const route = useRoute();
const activeLocale = obtainActiveLocale();
const activeCountry = obtainActiveWebCountry();
const langSwitcherModal = ref(false);

const desktopItems: ComputedRef<Array<MenuItem>> = computed(() => {
  for (const menuItem of props.content as Array<MenuItem>) {
    if (menuItem.name.toLowerCase() === 'desktop') {
      return menuItem.childs.map((m) => (new MenuItem()).fromObject(m) as MenuItem);
    }
  }
  return [];
});

const leftMenuItems: ComputedRef<Array<MenuItem>> = computed(() => {
  for (const menuItem of desktopItems.value) {
    if (menuItem.name.toLowerCase() === 'left') {
      return menuItem.childs.map((m) => (new MenuItem()).fromObject(m) as MenuItem);
    }
  }
  return [];
});

const centerMenuItems: ComputedRef<Array<MenuItem>> = computed(() => {
  for (const menuItem of desktopItems.value) {
    if (menuItem.name.toLowerCase() === 'center') {
      return menuItem.childs.map((m) => (new MenuItem()).fromObject(m) as MenuItem);
    }
  }
  return [];
});


const rightMenuItems: ComputedRef<Array<MenuItem>> = computed(() => {
  for (const menuItem of desktopItems.value) {
    if (menuItem.name.toLowerCase() === 'right') {
      return menuItem.childs.map((m) => (new MenuItem()).fromObject(m) as MenuItem);
    }
  }
  return [];
});

const isIndexPage: ComputedRef<boolean> = computed(() => {
  return route.path === '/';
})

const favoritesCount = computed(() => {
  return favorites.value.length;
});

const logout = () => {
  emit('logout');
}

const showLogin = () => {
  useState('login-modal').value = true;
}
const showLoginNewObject = () => {
  useState('login-modal').value = true;
}
</script>
